import React, { useState } from "react";

interface Pin {
  x: number;
  y: number;
  title: string;
  body: string;
  highlightX?: number;
  highlightY?: number;
  highlightWidth?: number;
  highlightHeight?: number;
  highlightColor?: string;
  highlightAlpha?: number;
}

interface AnnotatedImageProps {
  image?: string;
  imageSrc?: string;
  pins: Pin[];
}

export const AnnotatedImage: React.FC<AnnotatedImageProps> = ({
  image,
  imageSrc,
  pins,
}) => {
  const [active, setActive] = useState(0);

  return (
    <figure className="annotated">
      <div className="annotated__shot">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={image || "Screenshot"}
            crossOrigin="anonymous"
            className="annotated__image"
          />
        ) : (
          <div className="placeholder">
            <span>{image || "product screenshot"}</span>
          </div>
        )}
        {/* Highlight rectangles */}
        {pins.map((p, i) => {
          if (
            active === i &&
            p.highlightX !== undefined &&
            p.highlightY !== undefined &&
            p.highlightWidth !== undefined &&
            p.highlightHeight !== undefined
          ) {
            const color = p.highlightColor || "#0C98D0";
            const alpha =
              p.highlightAlpha !== undefined ? p.highlightAlpha : 0.2;
            return (
              <div
                key={`highlight-${i}`}
                style={{
                  position: "absolute",
                  left: `${p.highlightX}%`,
                  top: `${p.highlightY}%`,
                  width: `${p.highlightWidth}%`,
                  height: `${p.highlightHeight}%`,
                  backgroundColor: color,
                  opacity: alpha,
                  pointerEvents: "none",
                  borderRadius: "4px",
                  transition: "opacity 0.2s ease",
                }}
              />
            );
          }
          return null;
        })}
        {/* Pin buttons */}
        {pins.map((p, i) => (
          <button
            key={i}
            className={"annotated__pin" + (active === i ? " is-active" : "")}
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              transform: `translate(-50%,-50%) ${active === i ? "scale(1.12)" : ""}`,
            }}
            onClick={() => setActive(i)}
            aria-label={`Annotation ${i + 1}`}
          >
            {i + 1}
          </button>
        ))}
      </div>
      <div className="annotated__legend">
        {pins.map((p, i) => (
          <div
            key={i}
            className={
              "annotated__legend-item" + (active === i ? " is-active" : "")
            }
            onClick={() => setActive(i)}
          >
            <div className="annotated__legend-num">{i + 1}</div>
            <div className="annotated__legend-text">
              <h5>{p.title}</h5>
              <p>{p.body}</p>
            </div>
          </div>
        ))}
      </div>
    </figure>
  );
};
